import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.creator-brief-view': {
    backgroundColor: COLORS.WHITE,
    height: '100%',
    flex: 1,
    overflowY: 'scroll',
    '& .creator-brief-view__heading p': {
      height: '32px',
      marginBottom: theme.space[4],
      fontSize: theme.fontSizes[5],
    },
    '& .creator-brief-view__detail': {
      marginBottom: '1.25rem',
    },
  },
  '.creator-brief-view': {
    '&__content': {
      padding: theme.space[4],
    },
    '&__modules > *:not(:last-of-type)': {
      marginBottom: theme.space[6],
    },
    '&__modules > *': {
      borderRadius: '8px',
      border: `1px solid ${COLORS.NEUTRAL200}`,
      background: COLORS.NEUTRAL0,
      padding: '32px 16px',
      flexGrow: 0,
    },
    '&__check': {
      color: COLORS.PRIMARY300,
      marginRight: theme.space[2],
    },
    '&__invite-only': {
      margin: `1.25rem 0`,
    },
    '&__product-links + .creator-brief-view__shipping-required': {
      marginTop: theme.space[4],
    },
  },
});
